import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import LoadingSpinner from "../UI/LoadingSpinner";
import { getAppList } from "../../lib/api";
import { updateAppList } from "../../redux/appSlice";

const RelatedIssue = (props) => {

    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.user)
    const { appList } = useSelector((state) => state.app)

    const [selectedApp, setSelectedApp] = useState();
    const [isOptionSelected, setIsOptionSelected] = useState(false);

    const handleIssueSelection = (categoryId, categoryName) => {
        if (selectedApp === categoryId) {
            setSelectedApp(null);
            setIsOptionSelected(false);
            props.nextPage('', '');
        } else {
            setSelectedApp(categoryId);
            setIsOptionSelected(true);
            props.nextPage(categoryName, categoryId);
        }
    }

    useEffect(() => {
        if (appList === null || appList.length === 0) {
            props.setIsLoading(true)
            getAppList(currentUser)
                .then((response) => {
                    const filteredAppList = currentUser ? response.filter(app => app.user_type.includes(currentUser.user_extra_details.user_type)) : response
                    dispatch(updateAppList(filteredAppList))
                    props.setIsLoading(false)
                })
                .catch((error) => {
                    console.log(error);
                    props.setIsLoading(false)
                })
        }
    }, [currentUser, appList, dispatch, props])

    return (
        <div className="stepsContainer max-w-full lg:max-w-[70%] mx-auto">
            {props.isLoading && (
                <div className="parentDisable">
                    <LoadingSpinner />
                </div>
            )}
            <div className="mt-7 sm:mt-9">
                <div className="supportQueries mt-8 sm:mt-10 text-center">
                    <h3 className="text-lg leading-6 sm:text-2xl sm:leading-8 font-medium">1.Which resource is your question/issue related to? </h3>
                    <p className="text-base leading-5 sm:text-lg sm:leading-8 font-normal mt-1 hidden">Please select one of the following options.</p>
                </div>
                {appList && <div className="queriesList mt-8 max-w-[90%] mx-auto sm:max-w-[80%]">
                    <div className="flex items-center gap-3 sm:gap-5 *:bg-[#717375] *:px-4 *:py-[6px] sm:*:py-[10px] *:rounded-lg *:text-white *:leading-4 *:sm:text-xl *:sm:leading-5 *:text-base leading-5 *:font-medium flex-wrap justify-center *:cursor-pointer">
                        {appList.map((list, key) =>
                            <div
                                className={isOptionSelected ? selectedApp === list.nid ? 'selected' : 'hidden' : 'notSelected'}
                                key={key}
                                onClick={() => { handleIssueSelection(list.nid, list.title) }}
                            >
                                {list.title}
                            </div>
                        )}
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default RelatedIssue;
